export enum EAgreementsURL {
    CGV = 'https://wepoppins.com/cgv/',
    CGU = 'https://wepoppins.com/cgu/',
    CONFIDENTIALITY_POLICY = 'https://wepoppins.com/politique-de-confidentialite/',
    CHARTER_OF_GOOD_CONDUCT = 'https://wepoppins.com/charte-de-bonne-conduite/',
    IDENFY_CONFID_POLICY = 'https://wepoppins.com/idenfy-politique-de-confidentialite/'
};